import React, { useState } from 'react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Download, PlugZap, Save } from 'lucide-react';
import { getQzHost, setQzHost, checkQzConnection, qzErrorMessage } from '../lib/qzPrint';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const QzTrayPanel = () => {
  const [host, setHost] = useState(getQzHost());
  const [status, setStatus] = useState('');

  const save = () => { setQzHost(host); toast.success('QZ Tray address saved on this device'); };

  const test = async () => {
    setQzHost(host);
    setStatus('Connecting...');
    try {
      const version = await checkQzConnection();
      setStatus(`Connected to QZ Tray ${version}`);
    } catch (e) { setStatus(qzErrorMessage(e)); }
  };

  return (
    <Card data-testid="qz-tray-panel">
      <CardHeader><CardTitle className="flex items-center gap-2"><PlugZap className="w-5 h-5" />QZ Tray (direct printing)</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <ol className="text-sm text-muted-foreground list-decimal pl-5 space-y-1">
          <li>Install QZ Tray from <a className="text-primary underline" href="https://qz.io/download/" target="_blank" rel="noreferrer">qz.io/download</a> on the device that prints, and keep it running.</li>
          <li>Download the certificate below. In QZ Tray choose <strong>Advanced → Site Manager → +</strong> and add the file, or copy it as <code>override.crt</code> into the QZ Tray folder (Mac: <code>/Applications/QZ Tray.app/Contents/Resources/</code>), then restart QZ Tray. This stops the "Allow" pop-up.</li>
          <li>Leave the address as <code>localhost</code> if QZ Tray runs on this device; otherwise enter the IP of the computer running it.</li>
          <li>Add your receipt printer below with its network IP and port 9100, then press the test button on its row.</li>
        </ol>
        <div className="flex flex-col md:flex-row gap-3 md:items-end">
          <div className="space-y-2 md:w-72">
            <Label htmlFor="qz-host">QZ Tray address (this device)</Label>
            <Input id="qz-host" value={host} onChange={(e) => setHost(e.target.value)} placeholder="localhost" data-testid="qz-host-input" />
          </div>
          <Button variant="outline" onClick={save} data-testid="qz-host-save-btn"><Save className="w-4 h-4 mr-2" />Save</Button>
          <Button variant="outline" onClick={test} data-testid="qz-test-connection-btn"><PlugZap className="w-4 h-4 mr-2" />Test connection</Button>
          <Button variant="outline" asChild data-testid="qz-download-cert-btn">
            <a href={`${API}/print/qz-certificate/download`}><Download className="w-4 h-4 mr-2" />Download certificate</a>
          </Button>
        </div>
        {status && <p className="text-sm" data-testid="qz-status">{status}</p>}
      </CardContent>
    </Card>
  );
};
